import React from 'react';

import { LeaseTemplateBundleType } from '@zg-rentals/ts-leasing-client';

import type { Lease, Property } from '../models';
import DotloopLeaseUnsupportedToast from '../pages/LandlordLeaseView/ListView/DotloopLeaseUnsupportedToast';
import DocumentModal from '../pages/LandlordLeaseView/SelfServeView/DocumentModal';

type Props = {
  leaseId: string;
  lease?: Lease;
  property?: Property;
  isColandlord?: boolean;
  onClose(): void;
  onError?(error: string): void;
};

export default function DocumentPreviewSelector({ lease, leaseId, property, isColandlord, onClose, onError }: Props) {
  if (lease == null) {
    return null;
  }

  if (lease.documentBackend === LeaseTemplateBundleType.DOTLOOP) {
    return <DotloopLeaseUnsupportedToast isColandlord={isColandlord} />;
  }

  return <DocumentModal {...{ leaseId, lease, property, isColandlord, onClose, onError }} />;
}
